module.exports = __webpack_public_path__ + "media/images/accountSection__settings-7717545e96a28ea7f0ae34a306f7db9e.png";